package com.yet.tetris.feature.history

enum class DateFilter {
    ALL,
    TODAY,
    THIS_WEEK,
    THIS_MONTH,
}
